"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var DesktopDisabledSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M4.696,3.99992674 L5.362,4.99992674 L4,5 L4,12 L10.029,11.9999267 L11,13.4559267 L11,14 L11.363,13.9999267 L12.03,15 L5,15 L5,14 L7,14 L7,13 L4,13 C3.44771525,13 3,12.5522847 3,12 L3,5 C3,4.44771525 3.44771525,3.99992674 4,3.99992674 L4.696,3.99992674 Z M5.85946839,2.15233734 L5.91602515,2.2226499 L13.9160251,14.2226499 C14.0692014,14.4524142 14.0071144,14.7628489 13.7773501,14.9160251 C13.5731151,15.0521818 13.3051406,15.018254 13.1405316,14.8476627 L13.0839749,14.7773501 L5.08397485,2.7773501 C4.93079862,2.54758575 4.99288556,2.23715108 5.2226499,2.08397485 C5.42688487,1.9478182 5.69485937,1.98174603 5.85946839,2.15233734 Z M10,13 L8,13 L8,14 L10,14 L10,13 Z M8.302,3.99992674 L14,3.99992674 C14.5522847,3.99992674 15,4.44771525 15,5 L15,12 C15,12.4565846 14.6940022,12.8416996 14.2758956,12.9614559 L14,13 L13.636,11.9999267 L14,12 L14,5 L8.969,4.99992674 L8.302,3.99992674 Z" })));
};
DesktopDisabledSmall.displayName = 'DesktopDisabledSmall';
exports.default = DesktopDisabledSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=DesktopDisabledSmall.js.map